import { Modal } from 'rimble-ui'
import CustomButton from '../CustomButton'
import { useEffect, useState } from 'react'

export default function ModalSellConfirm(props) {
  const {toggleModal, setToggleModal, id, price, fn, processing} = props
  const [delay, setDelay] = useState(false)

  useEffect(() => {
    if (delay) {
      let timeout = setTimeout(() => {
        setDelay(false)
      }, 2000)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [delay])

  function sellItem() {
    if (!delay) {
      fn()
      setDelay(true)
    }
  }

  return (
    <>
      <Modal isOpen={toggleModal}>
        <div className='customModal modalSellConfirm'>
          <div className='nftInfo'>
            <div className='sellTitle'>SELL YOUR NFTs</div>
            <div className='sellId'>ID: {id}</div>
            <div className='sellPrice'>{price} BNB</div>
          </div>

          {
            processing
              ? <div className='groupBtnRow'>
                  <CustomButton 
                    text={'PROCESSING...'}
                    fn={() => {}}
                    type={'medium'}
                    transparent={true}
                    disabled={true}
                  />
                </div>
              : <div className='groupBtnRow'>
                  <CustomButton 
                    text={'CANCEL'}
                    fn={() => setToggleModal(false)}
                    type={'small'}
                    transparent={true}
                  />
                  
                  <CustomButton 
                    text={'CONFIRM'}
                    fn={() => sellItem()}
                    type={'small'}
                    transparent={false}
                  />
                </div>
          }
          
            
          
        </div>
      </Modal>
    </>
  )
}